/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EventLinkTypeBundle {
    LINK = 'LINK',
    MAILTO = 'MAILTO',
}
